import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResponseObject } from 'src/app/model/ResponseObject';
import { DropdownModal } from 'src/app/model/ComponentModels/dropdown-modal';
import { AppModel } from 'src/app/model/AppModel';
import { AsstntsrchServiceService } from 'src/app/services/AsstntsrchService';
import * as _ from 'lodash';
import { RadioModal } from 'src/app/model/ComponentModels/radio-modal';
import { AssistanceSearchInput } from 'src/app/model/EligibilityModels/AssistanceSearchInput';
import { Router } from '@angular/router';
import { ListOfValue } from 'src/app/model/EligibilityModels/ListOfValue';
import { RfrncDtItemsVO } from 'src/app/model/EligibilityModels/RfrncDtItemsVO';
import { AhctUtils } from 'src/app/core/services/AhctUtils';
import { AppRouteConstants } from 'src/app/core/constants/AppRouteConstants';
import { ApplnConstants } from 'src/app/core/constants/ApplnConstants';
import { ConfirmAssistance } from 'src/app/model/ConfirmAssistance';
import { AssistanceSearchResult } from 'src/app/model/EligibilityModels/AssistanceSearchResult';
import { SharedService } from 'src/app/services/shared.service';
import { markParentViewsForCheckProjectedViews } from '@angular/core/src/view/util';
import { ManageMyAssistanceR2RModel } from 'src/app/model/ManageMyAssistanceR2RModel';
import { ManageMyASTSCService } from 'src/app/services/ManageMyASTSCService';
import { ManageAccountModel } from 'src/app/model/ManageAccountModel';
import { AHCTAPIServices } from 'src/app/services/ahCTAPIServices';



@Component({
  selector: 'app-asstnt-srch-results',
  templateUrl: './asstnt-srch-results.component.html',
  styleUrls: ['./asstnt-srch-results.component.css'],

})
export class AsstntSrchResultsComponent implements OnInit {
  // data =[];
  public data: AssistanceSearchResult[];
  public needType: number;
  asstSearchInput: AssistanceSearchInput;
  config: any;
  collection = { count: 0, data: [] };
  /* Start R26 Related Changes */
  confirmAssistance: ConfirmAssistance = new ConfirmAssistance();
  assisterId: string;
  showConfDialog = false;
  name: string = '';
  

  isDataAvailable:boolean=false;
  startIndex: number;
  endIndex: number;
  /* End R26 Related Changes */

  /* Start R43 PT-17304 Related Changes */
  currentName: string = '';
  isCurrentAssister: boolean=false;
  isCurrentAssisterPending: boolean=false;
  showCurrDialog: boolean=false;
  isExistingAssister: boolean= false;
  noExistingAssister: boolean=false;
  currentConfirmAssistance: ConfirmAssistance = new ConfirmAssistance();
  existingAssisterId: string;
  existingAssisterReln: string;
  manageMyAssistanceR2RModel: ManageMyAssistanceR2RModel = new ManageMyAssistanceR2RModel();
  mngAccntMdl: ManageAccountModel = new ManageAccountModel;
  currentBrokerAddress: string = '';
  newBrokerAddress: string = '';
  /* End R43 PT-17304 Related Changes */

  
  userId: number;

  constructor(
    private _asstntSrchService: AsstntsrchServiceService,
    private _router: Router,
    private ahctUtils: AhctUtils,
    private asstInput: AssistanceSearchInput,
    private _sharedService : SharedService,
    private manageMyASTSCService: ManageMyASTSCService,
    private apiService: AHCTAPIServices
  ) {}

  ngOnInit() {
    this._sharedService.publicBrokerFlagChanges(true);
    this._sharedService.publicNonEnrollFlow(false);
    this.asstSearchInput = this._asstntSrchService.getApplnJsonNAsObj();
    // localStorage.removeItem(ApplnConstants.ASST_SEARCH_OBJECT);
    this.needType = this.asstSearchInput.needType;
    this._asstntSrchService
      .getSrchRslts(this.asstSearchInput)
      .subscribe(res => {
        const resp: ResponseObject = _.clone(res);
        if (resp.nextPath == 'SUCCESS') {
          /* this.collection.count = resp.objectsList.length;
          this.data = resp.objectsList;
          this.collection.data = resp.objectsList; */
          this.collection.count = resp.assistanceSearchResultList.length;
          this.data = resp.assistanceSearchResultList;
          this.collection.data = resp.assistanceSearchResultList;
          this.startIndex = 1;
          this.endIndex =
            this.startIndex + 9 > this.collection.count
              ? this.collection.count
              : this.startIndex + 9;
        }
        this.isDataAvailable=true;
      });
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.collection.count
    };
  }

  pageChanged(event) {
    this.config.currentPage = event;
    const currentPage = +event;
    this.startIndex =(10 * (currentPage-1))+ 1;
    this.endIndex =
      this.startIndex + 9 > this.collection.count
        ? this.collection.count
        : this.startIndex + 9;
  }

  /* Start R26 Related Changes */
  /*  checkSelect(assistId) {

    if (assistId != null && assistId.length > 0) {
      localStorage.setItem('assisterId', assistId);
    }
    this._router.navigateByUrl('/'+ AppRouteConstants.AST_SRCH_PRFX_MDUL + "/assistSearchActConfirm");
  } */

  checkSelect(assistId) {
     /* Start R43 PT-17304 Related Changes */
    this._sharedService.publicBreadCrumbFlagChange(true);
    this._sharedService.publicNonEnrollFlow(false);
    this._sharedService.publicAnonFlowChanges(false);
    
    this.apiService.loadDashboard(this.mngAccntMdl).subscribe(
      res => {
        this.mngAccntMdl = _.clone(res);
        console.log(this.mngAccntMdl.assistanceRequest);
        this.existingAssisterReln = this.mngAccntMdl.assistanceRequest.toString();
        
        
      console.log(this.existingAssisterReln);
      if (this.existingAssisterReln == '412' || this.existingAssisterReln == '409'){
        console.log("it has broker associated with it");  //it has broker associated with it 
        this.manageMyASTSCService.loadManageMyASTSC_RM().subscribe(
          res => {
            this.manageMyAssistanceR2RModel = _.clone(res);
            if (this.manageMyAssistanceR2RModel != null) {
              this.existingAssisterId =  this.manageMyAssistanceR2RModel.assisterId;
              this.existingAssisterReln = this.manageMyAssistanceR2RModel.assRelCd;
              console.log(this.existingAssisterId,this.existingAssisterReln );
              if(this.existingAssisterId != null){
                this.isExistingAssister = true;
                this._asstntSrchService.setExtAsstisterId(this.existingAssisterId);
                this._asstntSrchService.setExtAsstRelnCd(this.existingAssisterReln);
                if(assistId == this.existingAssisterId && this.existingAssisterReln =='412'){
                  this.isCurrentAssister=true;
                  this.showCurrDialog = true;
                }
                if(assistId == this.existingAssisterId && this.existingAssisterReln !='412'){
                  this.isCurrentAssisterPending=true;
                  this.showCurrDialog = true;   
                }
                if(assistId != this.existingAssisterId) { //(assistId != this.existingAssisterId)
                  localStorage.setItem('assisterId', this.existingAssisterId);
                  this._asstntSrchService.getAssistConfirmInfo(this.existingAssisterId).subscribe(res => {
                    const resp: ResponseObject = _.clone(res);
                    if (resp.nextPath === 'SUCCESS') {
                      this.currentConfirmAssistance = resp.object;
                      this.currentName =
                        this.currentConfirmAssistance.firstName +
                        ' ' +
                        this.currentConfirmAssistance.lastName;
                      //this._asstntSrchService.setAssisterNameInSession(this.currentName); //R43 CTHIX-45174
                      this.currentBrokerAddress = this.currentConfirmAssistance.addressLine1 + ', '
                      + (this.currentConfirmAssistance.addressLine2 && this.currentConfirmAssistance.addressLine2.trim().length > 0 ? this.currentConfirmAssistance.addressLine2 + ', ' : '')
                      + this.currentConfirmAssistance.city + ', '
                      + this.currentConfirmAssistance.zipCode;
                      console.log("current broker address:", this.currentBrokerAddress);
                    }
                  });
                  /* End R43 PT-17304 Related Changes */
                  localStorage.setItem('assisterId', assistId);
                  this._asstntSrchService.getAssistConfirmInfo(assistId).subscribe(res => {
                    const resp: ResponseObject = _.clone(res);
                    if (resp.nextPath === 'SUCCESS') {
                      this.confirmAssistance = resp.object;
                      this.name =
                        this.confirmAssistance.firstName +
                        ' ' +
                        this.confirmAssistance.lastName;
                      this._asstntSrchService.setAssisterNameInSession(this.name);
                      this.showConfDialog = true;
                      this.newBrokerAddress = this.confirmAssistance.addressLine1 + ', '
                      + (this.confirmAssistance.addressLine2 && this.confirmAssistance.addressLine2.trim().length > 0 ? this.confirmAssistance.addressLine2 + ', ' : '')
                      + this.confirmAssistance.city + ', '
                      + this.confirmAssistance.zipCode;
                      console.log("new broker address::", this.newBrokerAddress);
                    }
                  });
                }
              }
            }
          }
        );
      }else{
        if (assistId != null && assistId.length > 0) {
          this.noExistingAssister=true;
          localStorage.setItem('assisterId', assistId);
          this._asstntSrchService.getAssistConfirmInfo(assistId).subscribe(res => {
            const resp: ResponseObject = _.clone(res);
            if (resp.nextPath === 'SUCCESS') {
              this.confirmAssistance = resp.object;
              this.name =
                this.confirmAssistance.firstName +
                ' ' +
                this.confirmAssistance.lastName;
              this._asstntSrchService.setAssisterNameInSession(this.name);
              this.showConfDialog = true;
              this.newBrokerAddress = this.confirmAssistance.addressLine1 + ', '
                      + (this.confirmAssistance.addressLine2 && this.confirmAssistance.addressLine2.trim().length > 0 ? this.confirmAssistance.addressLine2 + ', ' : '')
                      + this.confirmAssistance.city + ', '
                      + this.confirmAssistance.zipCode;
                      console.log("future new broker address ::", this.newBrokerAddress);
            }
          });
        }
      }
    }
  );
    // this.existingAssisterReln = this.mngAccntMdl.assistanceRequest.toString();
    // console.log(this.existingAssisterReln);

  //   if(this.manageMyASTSCService.loadManageMyASTSC_RM() != null){
  //    
  //   }else{
  //       if (assistId != null && assistId.length > 0 && this.existingAssisterId == null) {
  //         localStorage.setItem('assisterId', assistId);
  //         this._asstntSrchService.getAssistConfirmInfo(assistId).subscribe(res => {
  //           const resp: ResponseObject = _.clone(res);
  //           if (resp.nextPath === 'SUCCESS') {
  //             this.confirmAssistance = resp.object;
  //             this.name =
  //               this.confirmAssistance.firstName +
  //               ' ' +
  //               this.confirmAssistance.lastName;
  //             this._asstntSrchService.setAssisterNameInSession(this.name);
  //             this.showConfDialog = true;
  //           }
  //         });
  //       }
  //     }
  // }
  
  
   }

  cancel() {
    this.showConfDialog = false;
    this.showCurrDialog = false;
  }

  submit() {
    this.showConfDialog = false;
    //localStorage.setItem('name',this.name);
    this._router.navigateByUrl(
      '/' + AppRouteConstants.AST_SRCH_PRFX_MDUL + '/assistSearchActConfirm'
    );
  }
  /* End R26 Related Changes */

  backButtonAction() {
    // localStorage.setItem('backFromResult','YES');
   //this._asstntSrchService.setApplnObjInSession(this.asstSearchInput);
    this._router.navigateByUrl(
      '/' + AppRouteConstants.AST_SRCH_PRFX_MDUL + '/assistSearch'
    );
  }

  ngOnDestroy() {
    this._sharedService.publicBrokerFlagChanges(false);
    this._sharedService.publicNonEnrollFlow(true);
  }
}
